import React from 'react'
import { CardRow, MultiLinkCard } from '@which/seatbelt'
import { IArticleCard } from '../../../data/shared/interfaces'

const ArticleCards = ({ title, cards }: IArticleCard): React.ReactElement => {
  if (cards.length === 0) return null

  return (
    <div className="article-cards-wrapper full-bleed" data-testid="article-cards-wrapper">
      <CardRow title={title}>
        {cards.map((card) => (
          <MultiLinkCard
            key={card.title}
            title={card.title}
            display="scroll-row"
            viewAllLink={card.viewAll}
            links={card.links}
            image={card.image}
            imageAlt={card.imageAlt}
          />
        ))}
      </CardRow>
    </div>
  )
}

export default ArticleCards
